import makeStyles from "@mui/styles/makeStyles";

export const useDailyCalendarTileStyles = makeStyles((theme) => ({
  center: {
    paddingTop: 5,
    textAlign: "center",
    width: "100%",
    fontSize: "small",
    color: theme.palette.mode === "light" ? "#000" : "#FFF",
  },
  container: {
    backgroundColor: theme.palette.mode === "light" ? "#FFF" : "#313233",
    borderRadius: 4,
    width: "100%",
    height: 80,
    cursor: "pointer",
    fontWeight: "bold",
    "&.disabled": {
      opacity: 0.6,
      cursor: "no-drop",
      backgroundColor: "black",
    },
    "&.available": {
      backgroundColor:
        theme.palette.mode === "light"
          ? theme.palette.primary.light
          : theme.palette.primary.main,
    },
  },
  day: {
    textAlign: "center",
    backgroundColor: theme.palette.mode === "light" ? "#D2D5D9" : "#3D3E40",
    borderRadius: "4px 4px 0 0",
    "&.currentDay": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  review: {
    padding: 8,
    position: "absolute",
    border: `2px solid #626466`,
    background: theme.palette.designSystem.palette.neutral1,
    zIndex: 100,
    display: "flex",
    alignItems: "space-between",
  },
  unlockSlotButton: {
    top: 5,
    right: 5,
    position: "absolute",
  },
  "@keyframes blinker": {
    from: { border: "5px solid #448FFF" },
    to: { border: "5px solid transparent" },
  },
  session: {
    position: "absolute",
    backgroundColor: theme.palette.background.default,
    // padding: 5,
    zIndex: 10,
    border: "2px solid transparent",

    "&.MuiPaper-root": {
      backgroundImage: `linear-gradient(to right, ${theme.palette.background.default}, ${theme.palette.background.default})`,
    },
    "&.selected": {
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        // border: "2px solid #2180F7",
        borderRadius: 5,
        backgroundColor: "#2180F71A",
      },
    },
    "&.locked": {
      backgroundColor: theme.palette.background.default,
    },
    "&.temporary": {
      display: "flex",
      alignItems: "center",
      backgroundColor: "white",
      color: "black",
      animationName: "$blinker",
      animationDuration: "2s",
      animationDirection: "alternate",
      animationTimingFunction: "linear",
      animationIterationCount: "infinite",
      zIndex: 99,
      cursor: "pointer",
    },
    "& .available": {
      backgroundColor: theme.palette.background.paperDarker,
    },
    "& .withSessionName": {
      "&::after": {
        content: ({ sessionName }) => `"${sessionName}"`,
        position: "absolute",
        top: -20,
        left: 0,
        zIndex: 999,
        width: "99px",
        height: "300px",
        border: "2px solid #2180F7",
        borderRadius: 5,
        backgroundColor: "#2180F71A",
      },
    },
  },
  divRow: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
  },
  ptName: {
    fontWeight: "bold",
    fontSize: 15,
  },
  date: {
    fontStyle: "italic",
    fontSize: "small",
    marginLeft: 5,
  },
  gender: {
    marginLeft: 5,
    borderRadius: 5,
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: "scale(0.7)",
    color: "#3D3E40",

    "&.male": {
      backgroundColor: "#92BFE2",
    },
    "&.female": {
      backgroundColor: "#F4BDD1",
    },
    "&.unspecified": {
      color: "#FFF",
      backgroundColor: "#313233",
    },
  },
  chip: {
    marginLeft: 10,
    marginRight: 10,
  },
  referral: {
    display: "inline-block",
    width: 40,
    margin: 1,
    height: 28,
    textAlign: "center",
    lineHeight: "30px",
    color: "#fff",
    borderRadius: 10,
    fontSize: "small",
    "&.completed": {
      border: "2px solid #000",
      color: "#000",
      lineHeight: "25px",
    },
  },
  lockedContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    zIndex: 30,
    width: "100%",
    backgroundColor: theme.palette.background.default,
    // background: `repeating-linear-gradient(-60deg, ${theme.palette.background.paperDarker}, ${theme.palette.background.paperDarker} 20px, ${theme.palette.background.default} 20px, ${theme.palette.background.default} 40px)`,
    borderRadius: 10,
    flexGrow: 1,
  },
  temporaryLockedContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    zIndex: 30,
    backgroundColor: "white",
  },
  darkSession: {
    backgroundColor: theme.palette.background.default,
    "&.MuiPaper-root": {
      backgroundImage: `linear-gradient(to right, ${theme.palette.background.default}, ${theme.palette.background.default})`,
    },
  },
  card: {
    overflowY: "auto",
  },
  zIndex: {
    zIndex: 10000000,
  },
  availableSlot: {
    flexGrow: 1,
    height: "100%",
    flexBasis: "100%",
    display: "flex",
    borderRadius: 8,
    width: "100%",
    alignItems: "center",
    cursor: 'default',
    justifyContent: "center",
    backgroundColor: theme.palette.background.paperDarker,

    "&.higherElevation": {
      zIndex: 999,
    },
  },
  availableSlotEditSection: {
    display: "flex",
    alignItems: "center",
    gap: 5,
    marginLeft: 10,
  },
  availableSlotBinIcon: {
    backgroundColor: theme.palette.error.main,
    borderRadius: 10,
  },
  timeIndicator: {
    zIndex: 1111,
    borderRadius: 10,
    position: "absolute",
    padding: "10px 16px",
    backgroundColor: theme.palette.background.default,
  },
  animation: {
    transition: "width 2s",
  },
  iconButtonsContainer: {
    "& button": {
      borderRadius: "10px",
      backgroundColor: theme.palette.background.paper,

      "&:hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
}));
